import React from 'react';

import {observer} from 'mobx-react';
import {SliderArrow} from './slider-arrow';
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {SliderCard} from "./slider-card";
import {SLIDER} from "../slider.consts";
import {SliderProps} from "./slider";
import {SliderEmptyState} from "./slider-empty-state";
import classNames from 'classnames';
import styles from '../style/slider.module.scss';

const ANIMATION_SPEED = 500;
export const SliderDesktop = observer(({
                                         controller,
                                         onSlide,
                                         onArrowClick,
                                         speed,
                                         emptyStateText,
                                         direction,
                                         showFirstTriangle,
                                         showLastTriangle,
                                         hasOdds,
                                         isRtl,
                                         height,
                                         items,
                                         CardComponent,
                                         cardComponentProps,
                                         ArrowComponent,
                                         arrowComponentProps,
                                         shouldRenderOverCardArrow,
                                         theme,
                                         forceArrows,
                                         moveItemOnClick,
                                         cardClassName
                                       }: SliderProps) => {
  const handlePrevClick = () => {
    const isChanged = controller.handlePrevClick();

    if (isChanged) {
      onSlide?.(SLIDER.ARROW_DIRECTION.prev);
      onArrowClick && onArrowClick(SLIDER.ARROW_DIRECTION.prev);
    }
  }

  const handleNextClick = () => {
    const isChanged = controller.handleNextClick();

    if (isChanged) {
      onSlide?.(SLIDER.ARROW_DIRECTION.next);
      onArrowClick && onArrowClick(SLIDER.ARROW_DIRECTION.next);
    }
  }

  const animationSpeed: Number = speed || ANIMATION_SPEED;

  const sliderCardContentProps: BaseProps = {
    className: classNames(styles.slider_cards_content),
    style: {
      [direction]: emptyStateText ? 0 : -1 * controller.currentPosition,
      transition: `all ${animationSpeed}ms`
    }
  }

  const sliderCardContainerProps: BaseProps = {
    className: classNames(styles.slider_cards_container, {[styles.over_card_arrows]: shouldRenderOverCardArrow}),
    ref: ref => ref && (controller.sliderContainerWidth = ref.getBoundingClientRect().width),
  }

  const containerProps = {
    className: classNames(styles.slider_desktop_container, {[styles.slider_desktop_container_first]: showFirstTriangle},
      {[styles.slider_desktop_container_last]: showLastTriangle}, styles.slider_container, {[styles.slider_container_has_odds]: hasOdds},
      {[styles.diagonal]: theme === SLIDER.THEMES.diagonal})
  }

  const emptyStateProps = {
    text: emptyStateText,
    className: classNames(styles.slider_widget_empty_state_desktop)
  }

  const shouldRenderBackwardArrow: Boolean = forceArrows || controller.firstArrowActive;
  const shouldRenderForwardArrow: Boolean = forceArrows || controller.lastArrowActive;

  return (
    <div {...containerProps}>
      {
        shouldRenderBackwardArrow ? (ArrowComponent ? <ArrowComponent {...arrowComponentProps} isPrev={true} onClick={() => handlePrevClick()}/> :
          <SliderArrow onClick={() => handlePrevClick()} isFirst active={controller.firstArrowActive} isRtl={isRtl}/>) : null
      }
      <div {...sliderCardContainerProps}>
        <div {...sliderCardContentProps}>
          {
            items?.map((item, index) => {
              return (
                <div key={index} ref={ref => controller.setSlideInIndex(index, ref)} onClick={() => moveItemOnClick(index)} >
                  <SliderCard
                              height={height} isRtl={isRtl}
                              isFirst={index === 0 && theme !== SLIDER.THEMES.diagonal}
                              isLast={index === items?.length - 1}
                              className={cardClassName}>
                    <CardComponent {...cardComponentProps} item={item} key={item.id} index={index}/>
                  </SliderCard>
                </div>
              )
            })
          }
          {
            emptyStateText && <SliderEmptyState {...emptyStateProps}/>
          }
        </div>
      </div>
      {
        shouldRenderForwardArrow ? (ArrowComponent ? <ArrowComponent {...arrowComponentProps} onClick={() => handleNextClick()}/> :
          <SliderArrow onClick={() => handleNextClick()} active={controller.lastArrowActive} isRtl={isRtl}/>): null
      }
    </div>
  );
});
